<template>
  <v-container>
    <div
      v-if="feedbackAlert.show"
      :class="[feedbackAlert.color, 'pa-4 elevetion-1']"
    >
      {{ feedbackAlert.message }}
    </div>
    <AppFilterNavigation
      ref="filters"
      :filters.sync="filters"
      filter-name="horsesFilters"
    >
      <template #default="prop">
        <v-col cols="12" md="2" class="px-1 mb-2 text-center">
          <AppSelectHorseTypes
            v-model="filters.horseAndPonyType"
            :label="
              $t(
                'events:event.masterlist.horsesPoniesFilter.label',
                'Horses/Ponies (official records)',
                'Label for horses or ponies status filter'
              )
            "
            data-test="types"
            :is-filter="!prop.mobile"
            :dense="prop.mobile"
            clearable
          />
        </v-col>

        <v-col cols="12" md="2" class="px-1 mb-2 text-center">
          <AppSelectStudbook
            v-if="showStudbookFilter"
            v-model="filters.studbookIds"
            :label="$t('horses:filters.studbook.label', 'Studbooks')"
            :input-props="{
              multiple: true,
              filterInput: true
            }"
          />
          <AppSelectBreeds
            v-else
            v-model="filters.breedIds"
            :is-filter="!prop.mobile"
            :dense="prop.mobile"
            multiple
            append-icon="$iconSearch"
            clearable
          />
        </v-col>

        <v-col cols="12" md="2" class="px-1 mb-2 text-center">
          <AppSelectCountries
            v-model="filters.birthCountryIds"
            :label="
              $t(
                'horses:filter.birthcountries.label',
                'Country of birth',
                'Label for country of birth filter'
              )
            "
            :is-filter="!prop.mobile"
            :menu-props="customMenuOptions"
            :input-props="{
              multiple: true,
              hideDetails: true
            }"
          />
        </v-col>

        <v-col cols="12" md="2" class="px-1 mb-2 text-center">
          <AppGenericTextField
            v-model="filters.birthYear"
            mask="####"
            :is-filter="!prop.mobile"
            :dense="prop.mobile"
            hide-details
            :label="
              $t(
                'horses:filter.yearofbirth.label',
                'Year of birth',
                'Label for year of birth filter'
              )
            "
            data-test="birthyear"
            append-icon="$iconSearch"
            outlined
            clearable
          />
        </v-col>

        <v-col
          v-if="$vuetify.breakpoint.mdAndUp"
          cols="12"
          md="4"
          class="px-1 mb-2 text-center"
        >
          <AppSearchBox :value.sync="filters.search" clearable />
        </v-col>
      </template>

      <template #advanced="prop">
        <v-col cols="12" md="3">
          <div class="px-1 mb-2 text-center">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <AppGenericTextField
                    v-model="filters.ownerName"
                    :label="
                      $t(
                        'horses:filter.ownername.label',
                        'Owner name',
                        'Label for owner name filter'
                      )
                    "
                    data-test="owner"
                    hide-details
                    :is-filter="!prop.mobile"
                    :dense="prop.mobile"
                    append-icon="$iconSearch"
                    outlined
                    class="white entsys--box entsys--custom-box"
                    clearable
                  />
                </div>
              </template>

              <span>
                {{
                  $t(
                    "common:filters.search.tooltip.FilterWithTyping",
                    "Please start typing a name (min 3 characters)",
                    "Tooltip for filters, when user should start typing the name"
                  )
                }}
              </span>
            </v-tooltip>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="px-1 mb-2 text-center">
            <AppGenericSelect
              v-model="filters.statusAndLicence"
              :items="statusAndLicence"
              ignore-checkboxes-view
              :menu-props="customMenuOptions"
              item-value="id"
              item-text="name"
              :label="
                $t(
                  'horses:filter.statusLicence.label',
                  'Status and licence',
                  'Label for status and licence filter'
                )
              "
              data-test="stausAndLicence"
              clearable
              multiple
              :is-filter="!prop.mobile"
              :dense="prop.mobile"
              hide-no-data
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="px-1 mb-2 text-center">
            <AppGenericSelect
              v-model="filters.feiItems"
              :items="FeiItems"
              ignore-checkboxes-view
              :menu-props="customMenuOptions"
              item-value="id"
              item-text="name"
              :label="
                $t(
                  'horses:filter.FEI.filter.title',
                  'FEI',
                  'Label for status and licence filter'
                )
              "
              data-test="statusAndPassort"
              clearable
              multiple
              :is-filter="!prop.mobile"
              :dense="prop.mobile"
              hide-no-data
              hide-details
            />
          </div>
        </v-col>
      </template>

      <template #mobile>
        <AppSearchBox :value.sync="filters.search" class="px-4" clearable />
      </template>
    </AppFilterNavigation>

    <div class="d-flex my-auto justify-end pa-3 flex-wrap align-center">
      <HorseImportCSV
        v-if="
          $auth.checkUserCanPerformMutationsInScopeAny('horseImportFromCsv')
        "
      />
      <v-btn
        v-if="
          $auth.checkUserCanPerformMutationsInScopeAny(
            'horseApplicationRegister'
          )
        "
        :to="{ name: 'HorseApplicationRegistration' }"
        dark
        small
        color="primary"
        class="profile-btn"
      >
        {{ $t("horses:button.horseApplicationRegister", "Register horse") }}
      </v-btn>

      <template v-if="$auth.canAccessRoute('HorseCreationPage')">
        <v-btn
          :to="{ name: 'HorseCreationPage' }"
          color="edit"
          large
          text
          class="px-4"
        >
          <b>
            <v-icon class="mr-1" color="edit">$edit</v-icon>
            {{ $t("horses:button.addHorse", "Horse") }}
          </b>
        </v-btn>
        <v-btn
          v-if="$auth.checkUserCanPerformMutationsInScopeAny('horseMerge')"
          :to="{ name: 'HorseDuplicateMerge' }"
          target="_blank"
          large
          text
          color="edit"
        >
          <b>
            <v-icon class="mr-1">$iconMerge</v-icon>
            {{ $t("horses:common.mergeDuplicates.button", "Merge duplicates") }}
          </b>
        </v-btn>
        <AppExportFile :prepare-function="exportHorses" use-tooltip />
      </template>
    </div>

    <v-card color="primary" class="fipa--header" tile />

    <SearchTemplateHorses
      data-test="horses"
      :items="horses"
      :loading="$apollo.queries.horses.loading"
      :hide-default-header="$vuetify.breakpoint.smAndDown"
    >
      <template
        v-if="
          !filters.statusAndLicence.includes('onlyInactive') &&
          !filters.statusAndLicence.includes('includeInactive')
        "
        #result-text
      >
        {{ $t("horses:HorsesSearchPage.noResultsTryIncludeInactive.hint") }}
      </template>
    </SearchTemplateHorses>
    <div class="text-right">
      <AppLoadMoreBtn
        :has-more-results="hasMoreResults"
        :loading="$apollo.queries.horses.loading"
        @loadMore="loadMore"
      />
    </div>
  </v-container>
</template>

<script>
import gql from "fraql";
import { useOrderReturnMsg } from "@composables/order_return_msg";
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import AppSelectCountries from "@AppSelects/AppSelectCountries.vue";
import { useHorsePonyTypesHelper } from "@composables/masterdata/ponyTypes";
import SearchTemplateHorses from "@/components/table_templates/Horses.vue";
import AppFilterNavigation from "@elements/AppFilterNavigation.vue";
import AppSearchBox from "@elements/AppSearchBox.vue";
import AppGenericTextField from "@AppSelects/AppGenericTextField.vue";
import AppGenericSelect from "@AppSelects/AppGenericSelect.vue";
import AppSelectHorseTypes from "@AppSelects/AppSelectHorseTypes.vue";
import AppLoadMoreBtn from "@elements/AppLoadMoreBtn.vue";
import AppExportFile from "@elements/AppExportFile.vue";
import AppSelectBreeds from "@AppSelects/AppSelectBreeds.vue";
import { exportSetPonyValue } from "@composables/export_file";
import HorseImportCSV from "./elements/HorseImportCSV.vue";
import AppSelectStudbook from "@AppSelects/AppSelectStudbook.vue";

const FILTERS = `
  $offset: Int
  $limit: Int
  $sortBy: String
  $sortDesc: Boolean
  $keyword: String
  $currentSeasonLicenceValid: Boolean
  $includeInactive: Boolean
  $onlyInactive: Boolean
  $hasIdentifiersFrom: [String]
  $breedIds: [ID]
  $studbookIds: [ID]
  $birthCountryIds: [ID]
  $birthYear: Int
  $ownerName: String
  $horseType: String
  $ponyType: String
  $hasIcelandicRegistryNumber: Boolean
  $hasWesternRegistryNumber: Boolean
  $hasFeiid: Boolean
  $feiPassportExpiresThisYear: Boolean
  $feiLicenceValidForDisciplineIds: [ID]
`;
const FILTER_VALUES = `
  offset: $offset
  limit: $limit
  sortBy: $sortBy
  sortDesc: $sortDesc
  keyword: $keyword
  currentSeasonLicenceValid: $currentSeasonLicenceValid
  includeInactive: $includeInactive
  onlyInactive: $onlyInactive
  hasIdentifiersFrom: $hasIdentifiersFrom
  breedIds: $breedIds
  studbookIds: $studbookIds
  birthCountryIds: $birthCountryIds
  birthYear: $birthYear
  ownerName: $ownerName
  horseType: $horseType
  ponyType: $ponyType
  hasIcelandicRegistryNumber: $hasIcelandicRegistryNumber
  hasWesternRegistryNumber: $hasWesternRegistryNumber
  hasFeiid: $hasFeiid
  feiPassportExpiresThisYear: $feiPassportExpiresThisYear
  feiLicenceValidForDisciplineIds: $feiLicenceValidForDisciplineIds
`;
export default {
  name: "HorseSearchPage",
  components: {
    SearchTemplateHorses,
    AppSearchBox,
    AppFilterNavigation,
    AppGenericSelect,
    AppLoadMoreBtn,
    AppGenericTextField,
    AppExportFile,
    AppSelectHorseTypes,
    AppSelectBreeds,
    HorseImportCSV,
    AppSelectStudbook,
    AppSelectCountries
  },
  setup() {
    const { feedbackAlert } = useOrderReturnMsg();
    const { horsePonyTypes } = useHorsePonyTypesHelper();
    return {
      ...useDisciplineHelper(),
      feedbackAlert,
      horsePonyTypes
    };
  },
  data() {
    return {
      inactiveComponent: false,
      horses: [],
      customMenuOptions: {
        closeOnContentClick: true
      },
      hasMoreResults: true,
      filtersCheck: true,
      filters: {
        currentSeasonLicenceValid: null,
        statusAndLicence: [],
        horseAndPonyType: null,
        ownerName: "",
        breedIds: [],
        studbookIds: [],
        birthCountryIds: [],
        birthYear: "",
        search: "",
        feiItems: []
      },
      sortBy: "name",
      sortDesc: false
    };
  },
  computed: {
    showStudbookFilter() {
      return this.$federation.countryCode == "BE";
    },
    filterVariables() {
      return {
        offset: 0,
        limit: 50,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        keyword: this.searchString,
        breedIds: this.filters.breedIds,
        studbookIds: this.filters.studbookIds,
        horseType: this.horseTypeFromFilter,
        ponyType: this.ponyTypeFromFilter,
        ownerName:
          this.filters.ownerName && this.filters.ownerName.length > 2
            ? this.filters.ownerName
            : "",
        birthCountryIds: this.filters.birthCountryIds,
        birthYear:
          this.filters.birthYear && this.filters.birthYear.length == 4
            ? Number(this.filters.birthYear)
            : null,
        currentSeasonLicenceValid: this.currentSeasonLicenceValidFromFilter,
        includeInactive: this.filters.statusAndLicence.includes(
          "includeInactive"
        )
          ? true
          : null,
        onlyInactive: this.filters.statusAndLicence.includes("onlyInactive")
          ? true
          : null,
        hasIdentifiersFrom: this.hasIdentifiersFromFromFilter,
        hasIcelandicRegistryNumber: this.filters.statusAndLicence.includes(
          "has_icelandicNumber"
        ),
        hasWesternRegistryNumber:
          this.filters.statusAndLicence.includes("has_westernNumber"),
        hasFeiid: this.filters.feiItems.includes("hasFeiid"),
        feiPassportExpiresThisYear: this.filters.feiItems.includes(
          "feiPassportExpiresThisYear"
        ),
        feiLicenceValidForDisciplineIds: this.filters.feiItems.filter(x =>
          this.feiDisciplineIds.includes(x)
        )
      };
    },
    FeiItems() {
      const items = [
        {
          header: this.$t(
            "horses:filter.FEI.statusAndPassportSubFilter.title",
            "Status and Passport"
          )
        },
        {
          name: this.$t("horses:filter.FEI.hasFeiid.label"),
          id: "hasFeiid"
        },
        {
          name: this.$t("horses:filter.FEI.feiPassportExpiresThisYear.label"),
          id: "feiPassportExpiresThisYear"
        },
        { divider: true },
        {
          header: this.$t(
            "horses:filter.FEI.validLicenceSubFilter.title",
            "Has valid FEI licence in"
          )
        }
      ];
      this.feiDisciplines.forEach(x => {
        x.name = x.i18n;
        items.push(x);
      });
      return items;
    },
    statusAndLicence() {
      return [
        {
          header: this.$t(
            "horses:filter.status.label",
            "Status",
            "Label for status filter"
          )
        },
        {
          name: this.$t(
            "horses:filter.status.onlyInactive.label",
            "Only inactive",
            "Label for status filter active"
          ),
          group: this.$t(
            "horses:filter.status.group.label",
            "Status",
            "Label for status group in status filter"
          ),
          id: "onlyInactive"
        },
        {
          name: this.$t(
            "horses:filter.status.includeInactive.label",
            "Include inactive",
            "Label for status filter inactive"
          ),
          group: this.$t(
            "horses:filter.status.group.label",
            "Status",
            "Label for status group in status filter"
          ),
          id: "includeInactive"
        },
        { divider: true },
        {
          header: this.$t(
            "horses:filter.licence.label",
            "Licence",
            "Label for licence filter"
          )
        },
        {
          name: this.$t(
            "horses:filter.licence.valid.label",
            "Valid",
            "Label for licence filter valid"
          ),
          group: this.$t(
            "horses:filter.licence.group.label",
            "Licence",
            "Label for licence group in status filter"
          ),
          id: "licence_valid"
        },
        {
          name: this.$t(
            "horses:filter.licence.invalid.label",
            "Invalid",
            "Label for licence filter invalid"
          ),
          group: this.$t(
            "horses:filter.licence.group.label",
            "Licence",
            "Label for licence group in status filter"
          ),
          id: "licence_invalid"
        },
        { divider: true },
        {
          header: this.$t(
            "horses:filter.licenceNumber.label",
            "Licence number",
            "Label for licence number filter"
          )
        },
        {
          name: this.$t(
            "horses:filter.licenceNumber.externalNumber.label",
            "Has HEPPA number",
            "Label for licence number filter HEPPA"
          ),
          group: this.$t(
            "horses:filter.origin.group.label",
            "Origin",
            "Label for origin group in status filter"
          ),
          id: "has_identifierHeppa"
        },
        {
          name: this.$t(
            "horses:filter.licenceNumber.internalNumber.label",
            "Has licence number",
            "Label for licence number filter internal"
          ),
          group: this.$t(
            "horses:filter.origin.group.label",
            "Origin",
            "Label for origin group in status filter"
          ),
          id: "has_licenceNumber"
        },

        {
          name: this.$t(
            "horses:filter.licenceNumber.IcelandicNumber.label",
            "Has icelandic number"
          ),
          group: this.$t(
            "horses:filter.origin.group.label",
            "Origin",
            "Label for origin group in status filter"
          ),
          id: "has_icelandicNumber"
        },
        {
          name: this.$t(
            "horses:filter.licenceNumber.WesternNumber.label",
            "Western number"
          ),
          group: this.$t("horses:filter.origin.group.label", "Origin"),
          id: "has_westernNumber"
        }
      ];
    },
    fields() {
      return [
        {
          value: "name",
          text: this.$t("horses:fields.name.label", "Horse", "Name field label")
        },
        {
          value: "currentSeasonLicenceValid",
          text: this.$t(
            "horses:fields.YearlyLicence.label",
            "Yearly licence",
            "Yearly licence field label"
          )
        },
        {
          value: "licenceNumber",
          text: this.$t(
            "horses:fields.LicenceNumber.label",
            "Licence / Reg.nr",
            "Licence number field label"
          )
        },
        {
          value: "status",
          text: this.$t(
            "horses:fields.status.label",
            "Status",
            "Status field label"
          )
        }
      ];
    },
    searchQueryVariables() {
      return {
        offset: 0,
        limit: 50,
        keyword: this.filters.keyword
      };
    },
    horseTypeFromFilter() {
      return this.filters.horseAndPonyType
        ? this.filters.horseAndPonyType == "only_horses"
          ? "horse"
          : "pony"
        : null;
    },
    ponyTypeFromFilter() {
      if (this.filters.horseAndPonyType) {
        const val = this.filters.horseAndPonyType.split("_")[1];
        return this.horsePonyTypes.includes(val) ? val : null;
      }
      return null;
    },
    currentSeasonLicenceValidFromFilter() {
      if (
        this.filters.statusAndLicence.includes("licence_valid") &&
        this.filters.statusAndLicence.includes("licence_invalid")
      ) {
        return null; // in case both are selected then no filter
      }
      if (this.filters.statusAndLicence.includes("licence_valid")) {
        return true;
      }
      if (this.filters.statusAndLicence.includes("licence_invalid")) {
        return false;
      }
      return null;
    },
    hasIdentifiersFromFromFilter() {
      let selectedIdentifierOrigins = [];
      if (this.filters.statusAndLicence.includes("has_identifierHeppa")) {
        selectedIdentifierOrigins.push("heppa");
      }
      if (this.filters.statusAndLicence.includes("has_licenceNumber")) {
        selectedIdentifierOrigins.push("kipa");
      }
      return selectedIdentifierOrigins;
    },
    searchString() {
      return this.filters.search ? this.filters.search : null;
    }
  },
  mounted() {
    this.$refs.filters.findURLParams();
    // Find if any params in URL and then send query
    // Prevents sending double queries, one and without variables
    this.filtersCheck = false;
  },
  activated() {
    this.inactiveComponent = false;
  },
  deactivated() {
    this.inactiveComponent = true;
  },
  apollo: {
    horses: {
      query: gql`
        query horses (${FILTERS}) {
          horses (${FILTER_VALUES}) {
            ${SearchTemplateHorses.fragments.horses}
          }
        }
      `,
      skip() {
        return this.filtersCheck || this.inactiveComponent;
      },
      variables() {
        return this.filterVariables;
      },
      result({ loading, data }) {
        if (loading || !data) return;
        this.hasMoreResults = data.horses.length >= 50;
      },
      fetchPolicy: "cache-and-network"
    }
  },
  methods: {
    loadMore() {
      this.$apollo.queries.horses
        .fetchMore({
          variables: {
            offset: this.horses.length
          }
        })
        .then(({ data: { horses } }) => {
          this.hasMoreResults = horses.length >= 50;
        });
    },
    async exportHorses() {
      const keyMap = [
        {
          column: this.$t(
            "horses:CsvKeys.ID.label",
            "ID",
            "Csv ID column label"
          ),
          key: "id"
        },
        {
          column: this.$t(
            "horses:CsvKeys.RegNr.label",
            "Reg nr",
            "Csv Reg nr column label"
          ),
          key: "identifier"
        },
        {
          column: this.$t(
            "horses:CsvKeys.name.label",
            "Name",
            "Csv name column label"
          ),
          key: "name"
        },
        {
          column: this.$t(
            "horses:CsvKeys.BirthName.label",
            "Birth name",
            "Csv birth name column label"
          ),
          key: "birthName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.DateBirth.label",
            "Date of birth",
            "Csv date of birth column label"
          ),
          key: "dateOfBirth"
        },
        {
          column: this.$t(
            "horses:CsvKeys.age.label",
            "Age",
            "Csv age column label"
          ),
          key: "ageForSeason"
        },
        {
          column: this.$t(
            "horses:CsvKeys.gender.label",
            "Gender",
            "Csv gender column label"
          ),
          key: "gender"
        },
        {
          column: this.$t(
            "horses:CsvKeys.CountryBirth.label",
            "Country of birth",
            "Csv country of birth column label"
          ),
          key: "birthCountry.ioc"
        },
        {
          column: this.$t(
            "horses:CsvKeys.breed.label",
            "Breed",
            "Csv breed column label"
          ),
          key: "breed.name"
        },
        {
          column: this.$t(
            "horses:CsvKeys.sire.label",
            "Sire",
            "Csv sire column label"
          ),
          key: "sireName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.dam.label",
            "Dam",
            "Csv dam column label"
          ),
          key: "damName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.SireDam.label",
            "Sire of dam",
            "Csv sire of dam column label"
          ),
          key: "damSireName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.owner.label",
            "Owner",
            "Csv owner column label"
          ),
          key: "ownerName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.breeder.label",
            "Breeder",
            "Csv breeder column label"
          ),
          key: "breederName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.color.label",
            "Color",
            "Csv color column label"
          ),
          key: "colorName"
        },
        {
          column: this.$t(
            "horses:CsvKeys.type.label",
            "Type",
            "Csv type column label"
          ),
          key: "horseType"
        },
        {
          column: this.$t(
            "horses:CsvKeys.PonyType.label",
            "Pony type",
            "Csv pony type column label"
          ),
          key: "ponyType",
          useGivenMethod: horse => exportSetPonyValue(horse.ponyType)
        },
        {
          column: this.$t(
            "horses:CsvKeys.PonyMeasurement.label",
            "Pony measurement",
            "Csv pony measurement column label"
          ),
          key: "currentPonyMeasurement.height"
        },
        {
          column: this.$t(
            "horses:CsvKeys.PonyMeasurementValid.label",
            "Pony measurement valid",
            "Csv pony measurement valid column label"
          ),
          key: "ponyMeasurementIsExpired",
          useGivenMethod: horse => (horse.ponyMeasurementIsExpired ? 0 : 1)
        },
        {
          column: this.$t(
            "horses:CsvKeys.LicenceValid.label",
            "Licence valid",
            "Csv licence valid column label"
          ),
          key: "currentSeasonLicenceValid",
          useGivenMethod: horse => (horse.currentSeasonLicenceValid ? 1 : 0)
        },
        {
          column: this.$t(
            "horses:CsvKeys.FEIID.label",
            "FEI ID",
            "Csv FEI ID column label"
          ),
          key: "feiid"
        },
        {
          column: this.$t(
            "horses:CsvKeys.HEPPAID.label",
            "HEPPA ID",
            "Csv HEPPA ID column label"
          ),
          key: "identifierHeppa",
          showCondition: () => this.$federation.countryCode == "FI"
        },
        {
          column: this.$t(
            "horses:CsvKeys.HeppaIDStatus.label",
            "HEPPA ID status",
            "Csv HEPPA ID status column label"
          ),
          key: "identifierHeppaStatus",
          showCondition: () => this.$federation.countryCode == "FI"
        },
        {
          column: this.$t(
            "horses:CsvKeys.InternalID.label",
            "KIPA ID",
            "Csv internal ID column label"
          ),
          key: "licenceNumber"
        },
        {
          column: this.$t(
            "horses:CsvKeys.InternalIDStatus.label",
            "KIPA ID status",
            "Csv internal ID status column label"
          ),
          key: "licenceNumberStatus"
        },
        {
          column: this.$t(
            "horses:CsvKeys.IcelandicRegistryNumber.label",
            "FEIF ID",
            "Csv internal ID status column label"
          ),
          key: "icelandicRegistryNumber",
          showCondition: () => this.$federation.countryCode == "FI"
        },
        {
          column: this.$t(
            "horses:CsvKeys.WesternRegistryNumber.label",
            "Western ID",
            "Csv internal ID status column label"
          ),
          key: "westernRegistryNumber",
          showCondition: () => this.$federation.countryCode == "FI"
        },
        {
          column: this.$t(
            "horses:CsvKeys.lastUpdated.label",
            "Last updated",
            "Csv last updated column label"
          ),
          key: "updatedAt"
        }
      ];

      const { data } = await this.$apollo.query({
        query: gql`
          query horsesExport(
           ${FILTERS}
          ) {
            horses(
             ${FILTER_VALUES}
            ) {
              id
              name
              birthName
              dateOfBirth
              ageForSeason
              gender
              birthCountryId
              birthCountry @client {
                id
                ioc
              }
              breedId
              breed @client {
                id
                name
              }
              sireName
              damName
              damSireName
              ownerName
              breederName
              colorName
              horseType
              ponyType
              currentPonyMeasurement {
                id
                height
              }
              ponyMeasurementIsExpired
              currentSeasonLicenceValid
              feiid
              identifier
              identifierHeppa
              identifierHeppaStatus
              licenceNumber
              licenceNumberStatus
              icelandicRegistryNumber
              westernRegistryNumber
              updatedAt
            }
          }
        `,
        variables: {
          ...this.filterVariables,
          offset: 0,
          limit: 2000
        }
      });

      this.$apollo.queries.horses.refetch({
        offset: 0
      });

      return {
        keyMap,
        items: data.horses,
        filename: "horses-export"
      };
    }
  }
};
</script>
